import React from "react"
import { VStack } from "@chakra-ui/react"
import { Control } from "react-hook-form"
import { BadgeElementType } from "sharedTypes/badge"
import EditorPane from "components/CanvasEditor/EditorPane"
import ColorProperty from "components/CanvasEditor/Inspector/ColorProperty"
import { usePrinterSwatches } from "components/BadgeBuilder/hooks/usePrinterColorConstraints"
import { BadgeElementFormValues } from "components/BadgeBuilder/Panels/EditorPanel/BadgeSidePanelForm"
import BorderControl from "./BorderControl"
import TransformControls from "./TransformControls"
import PositionSizeFields from "./PositionSizeFields"

type Props = {
  control: Control<BadgeElementFormValues>
  elementType?: BadgeElementType
}

const NO_FILL = [
  BadgeElementType.QR_CODE, BadgeElementType.IMAGE, BadgeElementType.LINE,
  BadgeElementType.RECTANGLE, BadgeElementType.OVAL,
]
const NO_BORDER = [BadgeElementType.LINE, BadgeElementType.RECTANGLE, BadgeElementType.OVAL]

/** Whether an element type has the Style section's fill, its border, and can be flipped. */
export const hasFill = (type?: BadgeElementType) => !!type && !NO_FILL.includes(type)
export const hasBorder = (type?: BadgeElementType) => !!type && !NO_BORDER.includes(type)
export const canFlip = (type?: BadgeElementType) => type !== BadgeElementType.QR_CODE

const CommonStylingFields = ({ control, elementType }: Props) => {
  const swatches = usePrinterSwatches()
  const hideFlipControls = !canFlip(elementType)
  const hideFillControls = !hasFill(elementType)
  const hideBorderControls = !hasBorder(elementType)

  return (
    <VStack spacing={6} align="stretch">
      <PositionSizeFields control={control} />

      {(!hideBorderControls || !hideFillControls) && (
        <EditorPane title="Style">
          {!hideBorderControls && <BorderControl control={control} />}
          {!hideFillControls && (
            <ColorProperty control={control} name="fill" label="Fill" {...swatches} />
          )}
        </EditorPane>
      )}

      <TransformControls control={control} hideFlipControls={hideFlipControls} />
    </VStack>
  )
}

export default CommonStylingFields
